import styled from "styled-components";
import rtan from "./CardRtan.png"

const CardRtan = styled.img`
      width: 86.68px;
height: 113.74px;
  flex-grow: 0;
  object-fit: contain;

    `

export default () => (
    <CardRtan src={"/rtan_rich.png"} alt={"부자 르탄"}/>
)


